import { FaIcon } from '@acp/core-ui';
import { Link } from '@chakra-ui/react';
import {
    faFacebookF, faInstagram, faLinkedinIn, faYoutube,
} from '@fortawesome/free-brands-svg-icons';

const socialIcons = [
    {
        icon: faFacebookF,
        url: 'https://www.facebook.com/DetectorInspector/',
    },
    {
        icon: faLinkedinIn,
        url: 'https://www.linkedin.com/company/detector-inspector-pty-ltd/',
    },
    {
        icon: faYoutube,
        url: 'https://www.youtube.com/channel/UCNm0zGiRltNBYEwAlmwYT5Q',
    },
    {
        icon: faInstagram,
        url: 'https://www.instagram.com/detector_inspector/',
    },
];

export function SocialIcons() {
    return socialIcons.map((socialIcon) => (
        <Link
            key={socialIcon.url}
            href={socialIcon.url}
            isExternal
            _hover={{ color: 'primary.500' }}
        >
            <FaIcon icon={socialIcon.icon} />
        </Link>
    ));
}
